import crypto from 'crypto'

/**
 * @author Mario Carrizales
 * @description Function to decrypt a messag for Boveda.
 * @updatedDate 18-10-2023
 * @param {String} message
 * @returns {Object}
 */
function decryptMessageBoveda(message) {
    const ENV = process.env
    let messageDecrypted = ''
    message = message.trim()

    const [ivObtain, encryptedDataObtain] = (typeof message === 'object') ? [message.iv, message.encryptedData] : [message.split('.')[0], message.split('.')[1]]

    const iv = Buffer.from(ivObtain, 'hex')
    const encryptedText = Buffer.from(encryptedDataObtain, 'hex')
    const decipher = crypto.createDecipheriv(`${ENV.REACT_APP_ENCRYPTION_ALGORITHM}`, Buffer.from(`${ENV.REACT_APP_ENCRYPTION_SECRET_KEY_BOVEDA}`), iv)
    let decrypted = decipher.update(encryptedText)
    decrypted = Buffer.concat([decrypted, decipher.final()])

    messageDecrypted = `${decrypted.toString()}`
    return messageDecrypted
}


export { decryptMessageBoveda }
